export const toastHandler = (
  toastTitle,
  toastMessage,
  toastVariant = 'error'
) => {
  return {
    title: toastTitle,
    message: toastMessage,
    variant: toastVariant,
    autoClose: 3000,
    withCloseButton: false,
  };
};
